module.exports = __webpack_public_path__ + "media/images/riders/GEORGE_BANNIGAN-2cca8c233ec7ad9a4684636573c04506.png";